import { BitbucketIcon, ConfluenceIcon, JiraCoreIcon, JiraServiceDeskIcon, JiraSoftwareIcon } from '@atlaskit/logo';
import React from 'react';

import OpsgenieIcon from '../ui/OpsgenieIcon';

export interface ProductType {
  icon: typeof React.Component;
  name: string;
  url: string;
}

export type PRODUCT_TYPE =
  | 'jira-core.ondemand'
  | 'jira-servicedesk.ondemand'
  | 'jira-software.ondemand'
  | 'confluence.ondemand'
  | 'opsgenie'
  | 'bitbucket';

export const PRODUCT_TYPES: { [key: string]: ProductType } = {
  bitbucket: {
    icon: BitbucketIcon,
    name: 'Bitbucket',
    url: 'unused',
  },
  'confluence.ondemand': {
    icon: ConfluenceIcon,
    name: 'Confluence',
    url: '/wiki',
  },
  'jira-core.ondemand': {
    icon: JiraCoreIcon,
    name: 'Jira Core',
    url: '/secure/BrowseProjects.jspa?=&selectedProjectType=business',
  },
  'jira-servicedesk.ondemand': {
    icon: JiraServiceDeskIcon,
    name: 'Jira Service Desk',
    url: '/secure/BrowseProjects.jspa?=&selectedProjectType=service_desk',
  },
  'jira-software.ondemand': {
    icon: JiraSoftwareIcon,
    name: 'Jira Software',
    url: '/secure/BrowseProjects.jspa?=&selectedProjectType=software',
  },
  opsgenie: {
    icon: OpsgenieIcon,
    name: 'Opsgenie',
    url: 'unused',
  },
};

export const ADVANCED_SEARCH_URL: { [key: string]: (root: string, term: string) => string } = {
  Bitbucket: (root, term) => `${root}/search?q=${term}`,
  Confluence: (root, term) => `${root}/wiki/search?text=${term}`,
  'Jira Service Desk': (root, term) => `${root}/secure/QuickSearch.jspa?searchString=${term}`,
  'Jira Software': (root, term) => `${root}/secure/QuickSearch.jspa?searchString=${term}`,
};

export enum WORKLENS_PRODUCT_TYPE {
  JIRA_BUSINESS = 'JIRA_BUSINESS',
  JIRA_SERVICE_DESK = 'JIRA_SERVICE_DESK',
  JIRA_SOFTWARE = 'JIRA_SOFTWARE',
  CONFLUENCE = 'CONFLUENCE',
  OPSGENIE = 'OPSGENIE',
  BITBUCKET = 'BITBUCKET',
}

export const WORKLENS_PRODUCT_TYPE_TO_PRODUCT_TYPE: { [key in WORKLENS_PRODUCT_TYPE]: PRODUCT_TYPE } = {
  BITBUCKET: 'bitbucket',
  CONFLUENCE: 'confluence.ondemand',
  JIRA_BUSINESS: 'jira-core.ondemand',
  JIRA_SERVICE_DESK: 'jira-servicedesk.ondemand',
  JIRA_SOFTWARE: 'jira-software.ondemand',
  OPSGENIE: 'opsgenie',
};

// Product types supported bu join site service
export const SUPPORTED_PRODUCT_TYPES: PRODUCT_TYPE[] = [
  'confluence.ondemand',
  'jira-core.ondemand',
  'jira-servicedesk.ondemand',
  'jira-software.ondemand',
];

export const getProductType = (key: string): ProductType => PRODUCT_TYPES[key];
export const getProductTypeFromWorklensType = (key: WORKLENS_PRODUCT_TYPE): ProductType =>
  getProductType(WORKLENS_PRODUCT_TYPE_TO_PRODUCT_TYPE[key]);
